// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3638":"75da7ca4","4799":"bbecf33b","8960":"c3b06131"}[chunkId] + ".chunk.css";
};